var _rect, _rect2, _rect3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGeneralBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 1024,
    viewBox: "0 0 1440 1024",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1024,
    fill: "url(#paint0_linear_8337_102973)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1024,
    fill: "url(#paint1_linear_8337_102973)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1400,
    fill: "url(#paint2_linear_8337_102973)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8337_102973",
    x1: 1541.09,
    y1: 1484.52,
    x2: -684.7,
    y2: 1046.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0379516,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0380516,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.588542,
    stopColor: "#CBE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ABC6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8337_102973",
    x1: 1541.09,
    y1: 1484.52,
    x2: -684.7,
    y2: 1046.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0379516,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0380516,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.588542,
    stopColor: "#CBE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ABC6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8337_102973",
    x1: 1541.09,
    y1: 2005.53,
    x2: -818.115,
    y2: 1663.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0379516,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0380516,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.588542,
    stopColor: "#CBE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ABC6FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneralBg);
export default __webpack_public_path__ + "static/media/general-bg.d9988c16ad44f6def94d603d89b526d2.svg";
export { ForwardRef as ReactComponent };